<template>
    <div class="container">
      <div class="titulo text-center">
      <h2><strong>REPORTE DE RESERVACIONES</strong></h2>
    </div>
  
      <div class="row mb-3">
        <div class="col-md-4">
          <label for="fechaInicio" class="form-label">Fecha Inicio</label>
          <input
            v-model="filtro.fechaInicio"
            type="date"
            id="fechaInicio"
            class="form-control"
          />
        </div>
        <div class="col-md-4">
          <label for="fechaFin" class="form-label">Fecha Fin</label>
          <input v-model="filtro.fechaFin" type="date" id="fechaFin" class="form-control" />
        </div>
        <div class="col-md-4 d-flex align-items-end">
          <button class="btn btn-primary w-100" @click="filtrarPorFechas">
            <i class="bi bi-search"></i> Buscar
          </button>
          <button class="btn btn-secondary w-100 ms-2" @click="mostrarTodas">
            <i class="bi bi-arrow-clockwise"></i> Mostrar Todas
          </button>
        </div>
      </div>
  
      <div class="table-responsive">
        <table
          id="reservacionesTable"
          class="table table-striped table-bordered"
          ref="reservacionesTable"
        >
          <thead>
            <tr>
              <th>#</th>
              <th>Folio</th>
              <th>Cliente</th>
              <th>Origen</th>
              <th>Destino</th>
              <th>Fecha</th>
              <th>Hora</th>
              <th>Total pasajeros</th>
              <th>Adultos</th>
              <th>Niños</th>
              <th>Total pago</th>
              <th>Metodo</th>
              <th>Estatus p.</th>
              <th>Conductor asignado</th>
              <th>Auto asignado</th>
              <th>Confirmacion de reservacion</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import $ from "jquery";
  import "datatables.net-bs5";
  import "datatables.net-buttons-bs5";
  import jszip from "jszip";
  import "datatables.net-buttons/js/buttons.html5";
  import "datatables.net-buttons/js/buttons.print";
  
  window.JSZip = jszip;
  
  export default {
    data() {
      return {
        filtro: { fechaInicio: "", fechaFin: "" },
      };
    },
    methods: {
      initDataTable(data) {
        const table = $(this.$refs.reservacionesTable);
  
        // Limpia y destruye cualquier instancia previa de DataTable
        if ($.fn.DataTable.isDataTable(this.$refs.reservacionesTable)) {
          table.DataTable().clear().destroy();
        }
  
        table.DataTable({
          data: data,
          columns: [
            { data: "IdRegistro", defaultContent: "#" },
            { data: "Folio", defaultContent: "Sin folio" },
            { data: "Cliente", defaultContent: "No asignado" },
            { data: "Origen", defaultContent: "Sin origen" },
            { data: "Destino", defaultContent: "Sin destino" },
            { data: "FechaReservacion", defaultContent: "Sin fecha" },
            { data: "HoraReservacion", defaultContent: "Sin hora" },
            { data: "TotalPasajeros", defaultContent: "0" },
            { data: "Adultos", defaultContent: "0" },
            { data: "Ninos", defaultContent: "0" },
            { data: "MontoPago", defaultContent: "$0.00" },
            { data: "MetodoPago", defaultContent: "No especificado" },
            { data: "EstatusPago", defaultContent: "Pendiente" },
            { data: "NombreConductor", defaultContent: "No asignado" },
            { data: "ModeloAuto", defaultContent: "No asignado" },
            { data: null, defaultContent: "Pendiente", title: "Confirmación" },
          ],
          responsive: true,
          dom: "Bfrtip",
          buttons: [
            {
              extend: "excelHtml5",
              text: "Exportar a Excel",
              title: "Reporte de Reservaciones",
            },
            {
              extend: "print",
              text: "Imprimir",
              title: "Reporte de Reservaciones",
            },
          ],
          language: {
            search: "Buscar:",
            zeroRecords: "No se encontraron resultados",
            lengthMenu: "Mostrar _MENU_ registros por página",
            info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
            infoEmpty: "No hay registros disponibles",
            infoFiltered: "(filtrado de _MAX_ registros totales)",
          },
        });
      },
      fetchReservaciones() {
        axios
          .get(
            this.$backendUrl+ "index.php/reservaciones/lista_completa"
          )
          .then((response) => {
            console.log("Datos recibidos:", response.data); // Debug: Verifica los datos
            this.initDataTable(response.data);
          })
          .catch((error) => console.error("Error al cargar reservaciones:", error));
      },
      filtrarPorFechas() {
        if (!this.filtro.fechaInicio || !this.filtro.fechaFin) {
          alert("Por favor selecciona ambas fechas para filtrar.");
          return;
        }
  
        axios
          .get(
           this.$backendUrl+ "/index.php/reservaciones/buscar_por_fechas",
            { params: this.filtro }
          )
          .then((response) => {
            console.log("Datos filtrados:", response.data); 
            this.initDataTable(response.data);
          })
          .catch((error) => console.error("Error al filtrar reservaciones:", error));
      },
      mostrarTodas() {
        this.filtro.fechaInicio = "";
        this.filtro.fechaFin = "";
        this.fetchReservaciones();
      },
    },
    mounted() {
      this.fetchReservaciones();
    },
  };
  </script>
  
  <style scoped>
  .titulo {
    background-color: #f52349; 
    color: white;
    font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
    font-size: 15px;
    padding: 15px 10px;
    margin: 5px 0 10px 0; 
  }
  .table-responsive {
    overflow-x: auto;
  }
  .dt-buttons {
    margin-bottom: 10px;
  }
  </style>
  